import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {AladinMouseMove} from './aladin-sky/aladin-sky.component';

@Injectable({
  providedIn: 'root'
})
export class AladinService {
  private searchPolygon = new BehaviorSubject<string>(undefined);
  private fov = new Subject<number>();
  private mouseMove = new Subject<AladinMouseMove>();
  private contextmenu = new Subject<MouseEvent>();
  private mouseClick = new Subject<MouseEvent>();

  getSearchPolygon(): Observable<string> {
    return this.searchPolygon.asObservable();
  }

  getSearchPolygonValue(): string {
    return this.searchPolygon.getValue();
  }

  setSearchPolygon(searchPolygon: string): void {
    this.searchPolygon.next(searchPolygon);
  }

  getFov(): Observable<number> {
    return this.fov.asObservable();
  }

  setFov(fov: number): void {
    this.fov.next(fov);
  }

  getMouseMove(): Observable<AladinMouseMove> {
    return this.mouseMove.asObservable();
  }

  setMouseMove(mouseMove: AladinMouseMove): void {
    this.mouseMove.next(mouseMove);
  }

  getContextmenu(): Observable<MouseEvent> {
    return this.contextmenu.asObservable();
  }

  setContextmenu(mouseEvent: MouseEvent): void {
    this.contextmenu.next(mouseEvent);
  }

  getMouseClick(): Observable<MouseEvent> {
    return this.mouseClick.asObservable();
  }

  setMouseClick(mouseClick: MouseEvent): void {
    this.mouseClick.next(mouseClick);
  }
}
